import { StripePrice } from "src/types"

// A Stripe price is charged in its own currency unless it carries an explicit
// option for the user's currency.
export default function resolvePrice({
  currency,
  stripePrice,
}: {
  currency: string
  stripePrice: StripePrice | undefined
}): { amountInCents: number; currency: string } | undefined {
  if (!stripePrice) return

  const currencyOption =
    stripePrice.currency_options?.[currency]?.unit_amount_decimal

  const amountInCents = parseFloat(
    currencyOption ?? stripePrice.unit_amount_decimal,
  )

  if (!amountInCents) return

  return {
    amountInCents,
    currency: currencyOption ? currency : stripePrice.currency,
  }
}
